/**
 * Newsletter section
 * ---------------------------------------------------------------------------
 * Extracted from sections/newsletter.liquid, where it was inline <script>.
 * Inline scripts are parser-blocking, uncacheable, and re-sent on every page
 * view. This asset is deferred and cached, and initialises every instance on
 * the page instead of binding to a single section id.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="newsletter"]';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.newsletterInit === 'true') return;
    sectionEl.dataset.newsletterInit = 'true';

    var sectionId = sectionEl.dataset.sectionId;
    // Clean up ?customer_posted=true from browser URL bar so subsequent refreshes don't re-trigger it
    if (window.location.search.includes('customer_posted=true')) {
      try {
        const newUrl = window.location.pathname + window.location.search.replace(/[?&]customer_posted=true/g, '').replace(/^&/, '?');
        window.history.replaceState({}, document.title, newUrl);
      } catch (e) {}
    }

    const form = sectionEl.querySelector('.custom-newsletter__form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const submitBtn = form.querySelector('.custom-newsletter__btn');
      const input = form.querySelector('.custom-newsletter__input');
      const inputGroup = form.querySelector('.custom-newsletter__input-group');

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';
      }

      const formData = new FormData(form);

      fetch(form.getAttribute('action') || '/contact#contact_form', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8'
        }
      })
      .then(() => {
        let msgBox = form.querySelector('.custom-newsletter__message--success');
        if (!msgBox) {
          msgBox = document.createElement('div');
          msgBox.className = 'custom-newsletter__message custom-newsletter__message--success';
          msgBox.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg><span></span>';
          var successSpan = msgBox.querySelector('span');
          if (successSpan) {
            successSpan.textContent = sectionEl.dataset.successMessage || 'Thanks for subscribing!';
          }
          form.insertBefore(msgBox, inputGroup);
        }
        msgBox.style.display = 'flex';
        if (input) input.value = '';

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
      })
      .catch(() => {
        form.submit();
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
